import { useCallback } from "react";
import PropTypes from "prop-types";
import { AppRouter } from "./AppRouter";

const AppRouterLimited = ({ routes, routesLimited }) => {
  const routesList = useCallback(() => {
    const routesLimitedList = Array.isArray(routesLimited)
      ? routesLimited
      : routes.map((route) => {
          return route.path;
        });
    const newRoutes = routes.map((route) => {
      return routesLimitedList.includes(route.path)
        ? {
            ...route,
            hasAccess: true,
          }
        : route;
    });

    return newRoutes;
  }, [routes, routesLimited]);

  return <AppRouter routes={routesList()} />;
};

AppRouterLimited.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      Component: PropTypes.elementType,
      exact: PropTypes.bool,
      isPrivate: PropTypes.bool,
      hasAccess: PropTypes.bool,
      navigation: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          path: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
  routesLimited: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

AppRouterLimited.defaultProps = {
  routesLimited: true,
};

export { AppRouterLimited };
